import React, { useState } from 'react';

import AuthCode from 'react-auth-code-input';
import '../resources/css/OTPEntry.css'
import API_CONSTANTS from '../resources/constants/api.json';

export default function OTPEntry (props) {  
  const emailValue = props.emailValue;
  const setResponseStatus = props.setResponseStatus
  const handleOnChange = async (res) => {
    if (res.length === 6){
      let response = await fetch(`${API_CONSTANTS.API_ROUTE}/validateotp?email=${emailValue}&otpEntry=${res.toUpperCase()}`,{method: 'POST'});
      let data = await response.json();
      if (response.status === 202) {
        console.log("logged user", data.user)
        props.navigateToDashboard(data.user)
      }
      else {
        setResponseStatus(data.error)
      }
    }
  };

  return (
    <AuthCode 
      containerClassName='container'
      inputClassName='input'
      onChange={handleOnChange}
      />
      )

    
};